import http from './http';

export async function getArticleCommmentsStatusListService() {
  try {
    const response = await http.get('/admin/article-comment/status-list')
    return response.data
  } catch (error) {
    console.error('Error al obtener la lista de estados:', error)
    throw error
  }
}

export async function articleCommmentsStatusChangeService(article_id, new_status_id) {
  try {
    const response = await http.post('/admin/article-comment/change-status', { id: article_id, status: new_status_id })
    return response.data
  } catch (error) {
    console.error('Error al eliminar el comentario:', error)
    throw error
  }
}

export async function deleteArticleCommentService(id) {
  try {
    const response = await http.post('/admin/article-comment/delete', { id })
    return response.data
  } catch (error) {
    console.error('Error al eliminar el comentario:', error)
    throw error
  }
}

export async function getArticleCommentDetailsService(id) {
  try {
    const response = await http.get(`/article-comment/details_id/${id}`)
    return response.data
  } catch (error) {
    console.error('Error al obtener el detalle del comentario:', error)
    throw error
  }
}

export async function updateArticleCommentService(id, comment) {
  try {
    const response = await http.post('/admin/article-comment/update-comment', { id, comment })
    return response.data
  } catch (error) {
    console.error('Error al actualizar el comentario:', error)
    throw error
  }
}

export async function updateArticleCommentDatesService(id, created_at, updated_at) {
  try {
    const response = await http.post('/admin/article-comment/update-dates', { id, created_at, updated_at })
    return response.data
  } catch (error) {
    console.error('Error al actualizar las fechas del comentario:', error)
    throw error
  }
}

export async function deleteArticleCommentMediaService(id) {
  try {
    const response = await http.post('/admin/article-comment/delete-media', { id })
    return response.data
  } catch (error) {
    console.error('Error al eliminar el archivo multimedia del comentario:', error)
    throw error
  }
}

export async function createArticleCommentService(formData) {
  try {
    const response = await http.post('/admin/article-comment/create', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
    return response.data
  } catch (error) {
    console.error('Error al crear el comentario:', error)
    throw error
  }
}

export async function getGridArticleCommentService(params) {
  const {
    page = 1,
    itemsPerPage = 10,
    sortBy = [],
    id = '',
    article_id = '',
    user_name = '',
    article_name = '',
    comment = '',
    assessment = 0,
    updated_at = ''
  } = params || {}

  let query = `?page=${page}&limit=${itemsPerPage}`
  if (id) query += `&id=${encodeURIComponent(id)}`
  if (article_id) query += `&article_id=${encodeURIComponent(article_id)}`
  if (user_name) query += `&user_name=${encodeURIComponent(user_name)}`
  if (article_name) query += `&article_name=${encodeURIComponent(article_name)}`
  if (comment) query += `&comment=${encodeURIComponent(comment)}`
  if (assessment > 0) query += `&assessment=${assessment}`
  if (updated_at) query += `&updated_at=${encodeURIComponent(updated_at)}`

  if (sortBy.length > 0) {
    query += `&sort=${sortBy[0].key}&order=${sortBy[0].order}`
  }

  try {
    const response = await http.get(`/admin/article-comment/grid${query}`)
    return response.data
  } catch (error) {
    console.error('Error in getGrid service:', error)
    throw error
  }
}